import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Checkbox, Radio, Row, Col } from "antd";
import { comma } from "../Func.js";
import { floor } from "lodash";
import { When, Else, If, Then } from "react-if";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { QRCodeSVG } from "qrcode.react";

function CretaBuyModal({
  refreshPage,
  address,
  profitData,
  userInfo,
  creta,
  setLoading,
  setCretaBuyModalOpen,
}) {
  const history = useHistory();
  const tronweb = window.tronWeb;

  const [cretaSalePrice, setCretaSalePrice] = useState(0);
  const [estimatedCreta, setEstimatedCreta] = useState(0);
  const [buyUsdtAmount, setBuyUsdtAmount] = useState("");
  const [usdtBalance, setUsdtBalance] = useState(0);
  const [currencyType, setCurrencyType] = useState("MATIC");

  const [buyMaticAmount, setBuyMaticAmount] = useState("");
  const [estimatedCretaByMatic, setEstimatedCretaByMatic] = useState("");

  const TRON_CRETA_SALE_ADDRESS = process.env.REACT_APP_TRON_CRETA_SALE_ADDRESS;
  const TRON_USDT_CONTRACT = process.env.REACT_APP_TRON_USDT_CONTRACT;

  const [depositAddressInfo, setDepositAddressInfo] = useState({});

  const getDepositAddress = useCallback(async () => {
    // setLoading(true);
    axios
      .post("api/getDepositAddress", {
        address: address,
      })
      .then((res) => {
        console.log(">>>>>>>>>>> data: ", res.data);

        setDepositAddressInfo(res.data);

        // if (res.data.status === "WAIT") {
        //   setTimeout(() => {
        //     getDepositAddress();
        //   }, 5000);
        // } else {
        //   setLoading(false);
        // }
      })
      .catch((err) => {
        //setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }, [setDepositAddressInfo, address]);

  const onChangeTerm = useCallback((e) => {
    setTerm(e.target.checked);
  }, []);

  const [term, setTerm] = useState(false);

  const onChangeBuyUsdt = (e) => {
    const { value, maxLength } = e.target;
    const amount = value.slice(0, maxLength);

    setBuyUsdtAmount(amount);
  };

  const setBuyUsdtAmountByPercent = (percent) => {
    setBuyUsdtAmount(floor((percent / 100) * usdtBalance));
  };

  const onChangeBuyMatic = (e) => {
    const { value, maxLength } = e.target;
    const amount = value.slice(0, maxLength);

    setBuyMaticAmount(amount);
  };

  const onChangeEstimatedCretaByMatic = (e) => {
    const { value, maxLength } = e.target;
    const amount = value.slice(0, maxLength);

    setEstimatedCretaByMatic(amount);
  };

  useEffect(async () => {
    setUsdtBalance(await getUsdtBalance());

    setCretaSalePrice(await getCretaSalePrice());
  }, []);

  useEffect(async () => {
    let c = floor((1 / cretaSalePrice) * buyUsdtAmount);
    console.log(c);
    if (isNaN(c)) {
      setEstimatedCreta(0);
    } else {
      setEstimatedCreta(c);
    }
    getDepositAddress();
  }, [buyUsdtAmount, getDepositAddress]);

  // useEffect(async () => {
  //   let c = floor(
  //     (userInfo.matic_exchange_price / cretaSalePrice) * buyMaticAmount
  //   );
  //   console.log(c);
  //   if (isNaN(c)) {
  //     setEstimatedCretaByMatic(0);
  //   } else {
  //     setEstimatedCretaByMatic(c);
  //   }
  // }, [buyMaticAmount]);

  useEffect(async () => {
    let c =
      Math.ceil(
        (cretaSalePrice / userInfo.matic_exchange_price) *
          estimatedCretaByMatic *
          100000
      ) / 100000;
    console.log(c);
    if (isNaN(c)) {
      setBuyMaticAmount(0);
    } else {
      setBuyMaticAmount(c);
    }
  }, [estimatedCretaByMatic]);

  const onChangeCurrencyType = useCallback(
    (e) => {
      setCurrencyType(e.target.value);
      let type = e.target.value;
      // let deposit = profitData.deposit;
      // if (type === "USDT") {
      // } else if (type === "CRETA") {
      // } else {
      // }
    },
    [setCurrencyType]
  );

  async function getUsdtBalance() {
    const { abi } = await tronweb.trx.getContract(TRON_USDT_CONTRACT);
    // console.log(JSON.stringify(abi));

    const contract = await tronweb.contract(abi.entrys, TRON_USDT_CONTRACT);

    const balance = await contract.methods.balanceOf(address).call();
    // console.log("balance:", balance.toString());

    return balance ? floor(balance / 1e6) : 0;
  }

  async function cretaBuyRequest() {
    if (buyUsdtAmount === "") {
      alert("Please enter the amount.");
      return;
    }
    if (+buyUsdtAmount <= 0) {
      alert("Please enter the amount.");
      return;
    }

    if (+buyUsdtAmount !== Math.ceil(buyUsdtAmount)) {
      alert("Please enter the amount without decimal.");
      return;
    }

    if (usdtBalance < buyUsdtAmount) {
      alert(
        `Insufficient USDT balance. (insufficient: ${
          buyUsdtAmount - usdtBalance
        } USDT)`
      );
      return;
    }

    if (estimatedCreta <= 0) {
      alert("The quantity of CRETA being purchased cannot be less than zero.");
      return;
    }

    if (!term) {
      alert("Please accept the terms and conditions.");
      return;
    }

    // ============================

    transfer(buyUsdtAmount);

    // ============================

    axios
      .post("api/cretaBuyTryLog", {
        address,
        price: cretaSalePrice,
        usdt: buyUsdtAmount,
        creta: estimatedCreta,
      })
      .then((res) => {
        //
      })
      .catch((err) => {
        //
      });
  }

  async function transfer(amount) {
    setLoading(true);
    try {
      let contract = await tronweb.contract().at(TRON_USDT_CONTRACT);

      console.log(">>>> contract: " + TRON_USDT_CONTRACT);
      console.log(">>>> from    : " + address);
      console.log(">>>> to      : " + TRON_CRETA_SALE_ADDRESS);

      await contract
        .transfer(
          TRON_CRETA_SALE_ADDRESS, //address _to
          amount * 1e6
        )
        .send({
          feeLimit: 1e9, // Set fee limit
          callValue: 0,
          userFeePercentage: 30,
          originEnergyLimit: 1e7,
        })
        .then(async (txid) => {
          console.log(txid);
          await txCheckFromBackend(txid); // transaction confirm 확인
        });
    } catch (error) {
      setLoading(false);
      console.error("trigger smart contract error", error);
      alert("The incorrect selection. Please select again.(code:3)");
    }
  }

  async function getSaleTxStatus(txid) {
    let result = await axios
      .post("api/getSaleTxStatus", {
        txid: txid,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return null;
      });

    return result;
  }

  async function getCretaSalePrice() {
    let result = await axios
      .post("api/getCretaSalePrice", {})
      .then((res) => {
        return res.data.price;
      })
      .catch((err) => {
        return 0;
      });

    return result;
  }

  async function txCheckFromBackend(txid) {
    for (let i = 0; i < 100; i++) {
      let result = await getSaleTxStatus(txid);
      if (result) {
        if (result.status === 1) {
          setLoading(false);
          alert("Transaction SUCCESS!");

          // history > dashboard 로 해야 창이 닫김
          history.push("/history");
          history.push("/dashboard");
          return;
        } else if (result.status === 2) {
          setLoading(false);
          alert("Transaction fail error.");

          // history > dashboard 로 해야 창이 닫김
          history.push("/history");
          history.push("/dashboard");
          return;
        } else {
          // ...
        }
      }

      await sleep(3000);
    }

    history.push("/history");
    history.push("/dashboard");
  }

  function sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  return (
    <div className="modal-body">
      <h2 className="mb-3">Buy CRETA</h2>

      <div className="profit-header">
        <p className="profit-name">CRETA Exchange Price</p>
        <span className="profit-data profit-data-usdt color-green">
          {" "}
          {comma(cretaSalePrice)}{" "}
        </span>
      </div>

      <hr />
      <h3>1. Select a currency.</h3>

      <Radio.Group onChange={onChangeCurrencyType} value={currencyType}>
        <Row>
          {/* <Col span={12} align="left">
            <Radio value={"USDT"}>USDT</Radio>
          </Col> */}
          <Col span={12} align="left">
            <Radio value={"MATIC"}>MATIC</Radio>
          </Col>
        </Row>
      </Radio.Group>

      <When condition={currencyType === "USDT"}>
        <h3 className="mt-3">2. Enter USDT amount.</h3>
        <div className="profit-header">
          <p className="profit-name">Balance of USDT</p>
          <span className="profit-data profit-data-usdt color-gold">
            {" "}
            {comma(Number(usdtBalance))}{" "}
          </span>
        </div>

        <div>
          <input
            type="number"
            min="0"
            max={creta}
            value={buyUsdtAmount}
            placeholder="Amount"
            onChange={onChangeBuyUsdt}
            maxLength={8}
          />
          <div className="flex-right mt-1">
            <button
              className="btn btn-sm btn-dark btn-shadow"
              onClick={() => setBuyUsdtAmountByPercent(30)}
            >
              30%
            </button>
            <button
              className="btn btn-sm btn-dark btn-shadow ml-1"
              onClick={() => setBuyUsdtAmountByPercent(50)}
            >
              50%
            </button>
            <button
              className="btn btn-sm btn-dark btn-shadow ml-1"
              onClick={() => setBuyUsdtAmountByPercent(100)}
            >
              100%
            </button>
          </div>
        </div>

        <div className="flex-center mt-3">
          <hr className="thin" />
          <div className="interest">
            <strong> ≈ {comma(Math.floor(estimatedCreta))}</strong> CRETA
          </div>
        </div>

        <div className="checkT mt-3">
          <h3 className="caution2">
            3. The CRETA amount is determined by the CRETA price at the time
            when the transaction is confirmed, not at the time of payment.
          </h3>

          <div className="caution">
            <Checkbox
              className="user-term"
              checked={term}
              onChange={onChangeTerm}
            >
              {" "}
              Agree
            </Checkbox>
          </div>
        </div>
      </When>
      <When condition={currencyType === "MATIC"}>
        <If
          condition={
            depositAddressInfo && depositAddressInfo.status === "SUCCESS"
          }
        >
          <Then>
            <h3 className="mt-3">2. Enter CRETA amount.</h3>
            <div className="profit-header">
              <p className="profit-name">MATIC Exchange Price</p>
              <span className="profit-data profit-data-usdt color-gold">
                {" "}
                {comma(Number(userInfo.matic_exchange_price).toFixed(5))}{" "}
              </span>
            </div>

            <div>
              <input
                type="number"
                min="0"
                max={creta}
                value={estimatedCretaByMatic}
                placeholder="Amount"
                onChange={onChangeEstimatedCretaByMatic}
                maxLength={8}
              />
            </div>

            <div className="flex-center mt-3">
              <hr className="thin" />
              <div className="interest">
                <strong> ≈ {comma(buyMaticAmount)}</strong> MATIC
              </div>
            </div>

            <div className="qrcode mt-3">
              <div className="help text-left">
                Please send{" "}
                <span className="color-gold">
                  {comma(Number(buyMaticAmount))}
                </span>{" "}
                Matic directly to your CRETA wallet below to receive
                approximately{" "}
                <span className="color-gold">
                  {comma(Math.floor(estimatedCretaByMatic))}
                </span>{" "}
                CRETA tokens.
              </div>

              <div className="w-100  mt-3">
                <QRCodeSVG value={depositAddressInfo?.address} size={128} />
              </div>

              <div className="w-100 mt-3 mb-3">
                <CopyToClipboard
                  text={depositAddressInfo.address}
                  onCopy={() => alert("Copied! ")}
                >
                  <button className="btn btn-md btn-primary">
                    Copy to clipboard
                  </button>
                </CopyToClipboard>
              </div>

              <div className="address mt-3 mb-3">
                {depositAddressInfo.address}
              </div>
            </div>

            <div className="checkT mt-3">
              <h3 className="caution2">
                3. The CRETA amount is determined by the CRETA price at the time
                when the transaction is confirmed, not at the time of payment.
              </h3>
              <When condition={currencyType === "USDT"}>
                <div className="caution">
                  <Checkbox
                    className="user-term"
                    checked={term}
                    onChange={onChangeTerm}
                  >
                    {" "}
                    Agree
                  </Checkbox>
                </div>
              </When>
            </div>
          </Then>

          <Else>
            <div className="qrcode mt-3">
              <div className="text-center color-gold p-3">
                There is no address to send MATIC. On the Dashboard screen,
                press the 'Deposit' button to generate your address.
              </div>
            </div>
          </Else>
        </If>
      </When>

      <hr />
      <div className="flex-space-between mt-1">
        <button
          className="btn btn-md btn-secondary"
          onClick={() => setCretaBuyModalOpen(false)}
        >
          close
        </button>

        <When condition={currencyType === "USDT"}>
          <button
            className="btn btn-md btn-primary"
            onClick={() => cretaBuyRequest()}
          >
            Buy
          </button>
        </When>
      </div>
    </div>
  );
}

export default CretaBuyModal;
